export function toRentalPortalTimelineItems(items) {
  const firstOpenIndex = items.findIndex(item => !item.isDone)

  return items.map((item, index) => ({
    ...item,
    isLast: index === items.length - 1,
    isLineDone: firstOpenIndex === -1 || index + 1 < firstOpenIndex,
  }))
}
